import React, { useMemo } from 'react';
import { getAggregateStats, getDomainAccuracyAcrossApps, getScoreTrend, getStudyActivity, getDomainReadiness } from '../shared/engine/progressAggregator';
import { getStreakData } from '../shared/engine/streakTracker';
import { detectWeaknesses, getStudyRecommendation } from '../shared/engine/studyRecommender';
import OverviewCards from './OverviewCards';
import DomainRadarChart from './charts/DomainRadarChart';
import ScoreTrendChart from './charts/ScoreTrendChart';
import StudyActivityChart from './charts/StudyActivityChart';
import DomainReadinessBars from './charts/DomainReadinessBars';
import WeaknessAlerts from './WeaknessAlerts';
import StudyRecommendation from './StudyRecommendation';

/**
 * Dedicated progress dashboard with all Recharts visualizations.
 */
export default function ProgressPage() {
  const stats = useMemo(() => getAggregateStats(), []);
  const streak = useMemo(() => getStreakData(), []);
  const domainAccuracy = useMemo(() => getDomainAccuracyAcrossApps(), []);
  const scoreTrend = useMemo(() => getScoreTrend(), []);
  const activity = useMemo(() => getStudyActivity(30), []);
  const domainReadiness = useMemo(() => getDomainReadiness(), []);
  const weaknesses = useMemo(() => detectWeaknesses(), []);
  const recommendation = useMemo(() => getStudyRecommendation(), []);

  return (
    <div className="px-4 py-6 max-w-6xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-white mb-1">Progress Dashboard</h1>
        <p className="text-gray-400 text-sm">Cross-app analytics for ENCOR exam readiness</p>
      </div>

      {/* Overview stats */}
      <OverviewCards stats={stats} streak={streak} />

      {/* Recommendation */}
      <div className="mb-6">
        <StudyRecommendation recommendation={recommendation} />
      </div>

      {/* Charts grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <DomainRadarChart domainAccuracy={domainAccuracy} />
        <ScoreTrendChart scoreTrend={scoreTrend} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <StudyActivityChart activity={activity} />
        <DomainReadinessBars domainReadiness={domainReadiness} />
      </div>

      {/* Weakness alerts */}
      <div className="mb-6">
        <WeaknessAlerts alerts={weaknesses} />
      </div>
    </div>
  );
}
